import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import Instance from "../../AxiosConfig";

const EditManagerModal = ({ show, handleClose, managerData, fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  // ✅ Prefill fields when agentData changes
  useEffect(() => {
    if (managerData) {
      setName(managerData.agentName || "");
      setEmail(managerData.email || "");
      setMobileNumber(managerData.number || "");
    }
  }, [managerData]);

  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
      setMobileNumber("");
    }
  }, [show]);

  const handleSave = async () => {
    try {
      const putResponse = await Instance.put(`/agents/${managerData._id}`, {
        agentName: name,
        agentEmail: email,
        agentNumber: mobileNumber,
        role: "MANAGER",
      });

      console.log("manager id", managerData._id);

      if (putResponse.status === 200 || putResponse.status === 201) {
        message.success("Manager details updated!");
        handleClose();
        fetchData();
      } else {
        message.error("Failed to update manager details.");
      }
    } catch (error) {
      console.error("Update error:", error);
      message.error("Failed to update manager details.");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Manager</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">Manager Name</label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !name ? "input-error" : ""
                  }`}
                  placeholder="Enter Manager name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className={`form-control ${
                    submitted && !email ? "input-error" : ""
                  }`}
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  className="form-control"
                  type="text"
                  value={mobileNumber}
                  onChange={(e) => {
                    setMobileNumber(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                type="button"
                className="agents-discard-button"
                onClick={handleClose}
              >
                Discard Changes
              </button>

              <button
                type="button"
                className="agents-save-button"
                onClick={handleSave}
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditManagerModal;
